import './footer.css'
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer>
            <div className='footergrid'>
                <div>
                <h2>- Brian -</h2>
                <div>
                    <p>Links:</p>
                    <ul>
                        <li><Link to="/About">About Me</Link></li>
                        <li><Link to="/hire">Hire Me</Link></li>
                        <li><a href="https://www.linkedin.com/in/brian-the-dev/">LinkedIn</a></li>
                        <li><a href="https://github.com/BrianTheDevGuy">Github</a></li>
                        <li><a href='https://brianthedevguy.itch.io/'>Itch.io</a></li>
                    </ul>
                </div>
                </div>
                <div>
                <h2>- Lets Connect! -</h2>
                <div>
                    <p>Contact Info:</p>
                    <ul>
                        <li><a href="mailto:brianayala2050@gmail.com">brianayala2050@gmail.com</a></li>
                    </ul>
                </div>
                </div>
            </div>
            <br/><br/>
            © 2025 Brian. All rights reserved.
        </footer>
    );
}

export default Footer;
